export const MigrosEngagementTheme = {
  name: 'Migros-Engagement Theme',
  themeId: 'migrosEngagement',
  colors: {
    brand: {
      primary: {
        100: '#C4390A'
      },
      secondary: {
        100: '#C4390A'
      },
      accent: {
        100: '#9B2700'
      },
      text: {
        100: '#1C1C1C'
      },
      grayout: {
        100: '#DDDDDD'
      }
    },
    tints: {
      gray: {
        50: '#939393',
        75: '#696969'
      }
    }
  },
  shadows: {
    base: '0px 8px 20px rgba(0, 0, 0, 0.1)'
  },
  fonts: {
    families: {
      heading: '"Helvetica Now Display", "Helvetica", arial, sans-serif',
      subHeading: '"Helvetica Now Display", "Helvetica", arial, sans-serif'
    },
    weights: {
      bold: 700
    },
    sizes: {
      text: {
        tiny: '16px',
        xsmall: '18px',
        small: '21px',
        medium: '24px',
        large: '26px',
        xlarge: '28px',
        huge: '30px'
      },
      heading: {
        tiny: '16px',
        xsmall: '20px',
        small: '24px',
        medium: '28px',
        large: '34px',
        xlarge: '36px',
        huge: '40px'
      }
    }
  },
  spacings: {
    tiny: '2px',
    xsmall: '5px',
    small: '10px',
    medium: '16px',
    large: '20px',
    xlarge: '32px',
    huge: '40px'
  },
  borderRadiuses: {
    xsmall: '2px',
    small: '4px',
    medium: '40px',
    large: '50px'
  }
};